'use client';

import React from 'react';
import Link from 'next/link';
import type { ProductListItem } from '@/common/types/product.type';
import { useDomainStore } from '@/store/use-domain.store';
import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Price from '@/common/components/price/price.component';
import { appConfigs } from '@/common/configs/app.config';
import { rialToToman } from '@/common/utils/money-exchange.utility';
import ProductDisplay from './product-display.component';

interface ProductProps {
  itemDetail: ProductListItem;
  vendorSlug: string;
}
function Product({ itemDetail, vendorSlug }: ProductProps) {
  const { id, price, discount, name, productSlug, ...rest } = itemDetail;
  const discountNum = Math.round(discount * 100);
  const isTenant = useDomainStore((store) => store.isTenant);
  const formattedPrice = rialToToman(price, appConfigs.rialExchangeRate);
  const link = isTenant
    ? `/product/${id}/${productSlug}`
    : `/${vendorSlug}/${id}/${productSlug}`;
  return (
    <article
      className="box-border h-full  overflow-hidden border-none lg:max-w-[20vw]"
      id={id?.toString()}
      data-id="store-click-product-v1"
    >
      <AnalyticsWrapper analytics={['store-click-product-v1']}>
        <Link href={link}>
          <ProductDisplay
            productName={itemDetail.name}
            availability={rest.availability}
            thumbnailImage={rest.thumbnailImage}
            discount={discountNum}
          />
          <h3 className="mb-1 line-clamp-1 min-h-4 text-ellipsis text-xs font-medium lg:text-sm">
            {name}
          </h3>
          {/* SEO: plain textual price for crawlers (hidden visually) */}
          <p className="sr-only">{`قیمت: ${formattedPrice} ${appConfigs.currency}`}</p>
          <Price
            price={formattedPrice}
            discount={discountNum !== 0 ? discountNum : undefined}
            alignment="horizontal"
            priceClassName="text-black-default  text-sm  lg:text-sm font-medium"
            discountClassName="text-black-300 text-sm lg:text-sm  font-medium leading-[18px]"
          />
        </Link>
      </AnalyticsWrapper>
    </article>
  );
}

export default Product;
